import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'
import swal from 'sweetalert'
import { FormattedMessage, injectIntl } from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class TwoFATotp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: { code: '' },
            redirectTo: null,
            errors: [],
            loading: false,
            showRecovery: false,
        };
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleCodeSubmit = this.handleCodeSubmit.bind(this);
        this.handleRecoverySubmit = this.handleRecoverySubmit.bind(this);
        this.loginRandom = null;
    }

    getBrandedLogo(defaultFilename, visibilityConfigKey) {
        if (visibilityConfigKey && ConfigBusiness.get(visibilityConfigKey) === "false") return null;
        var slug = ConfigBusiness.get("generales.clienteSlug");
        if (slug && slug !== "false" && slug !== "default") return process.env.PUBLIC_URL + "/images/branding/" + slug + "/" + defaultFilename;
        return process.env.PUBLIC_URL + "/images/company/" + defaultFilename;
    }

    componentWillMount() {
        if (!localStorage.getItem("persona")) {
            this.setState({ redirectTo: '/' });
        }
        this.formValidation = new FormValidation({
            component: this, validators: { 'formData.code': function(value) { return Validator.notEmpty(value); } }
        });
    }

    componentDidMount() {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');
    }

    handleFormChange(event) {
        var formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[event.target.name] = event.target.value;
        this.setState({ formData: formDataCopy, errors: [] });
    }

    handleCodeSubmit(event) {
        event.preventDefault();
        this.setState({ loading: true, errors: [] });
        fetch(Config.get('apiUrlBase') + '/public/2fa/totp/verify', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: this.state.formData.code, token: localStorage.getItem('token') }),
        }).then(function(response) {
            response.json().then(function(data) {
                if (response.status === 200) {
                    this.setState({ redirectTo: '/' });
                    window.location.reload();
                } else if (response.status === 400) {
                    swal("Atención", this.props.intl.formatMessage(backendStrings[data.error] ? backendStrings[data.error] : backendStrings['errors.default']), "warning");
                } else {
                    this.error();
                }
            }.bind(this)).catch(function() { this.error(); }.bind(this));
        }.bind(this)).catch(function() { this.error(); }.bind(this)).finally(function() { this.setState({ loading: false }); }.bind(this));
    }

    handleRecoverySubmit(event) {
        event.preventDefault();
        this.setState({ loading: true, errors: [] });
        fetch(Config.get('apiUrlBase') + '/public/2fa/recovery/verify', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: this.state.formData.code, token: localStorage.getItem('token') }),
        }).then(function(response) {
            response.json().then(function(data) {
                if (response.status === 200) {
                    this.setState({ redirectTo: '/' });
                    window.location.reload();
                } else if (response.status === 400) {
                    swal("Atención", this.props.intl.formatMessage(backendStrings[data.error] ? backendStrings[data.error] : backendStrings['errors.default']), "warning");
                } else {
                    this.error();
                }
            }.bind(this)).catch(function() { this.error(); }.bind(this));
        }.bind(this)).catch(function() { this.error(); }.bind(this)).finally(function() { this.setState({ loading: false }); }.bind(this));
    }

    handleGoHome() { this.setState({ redirectTo: '/' }); }

    error() { swal("Error", "Contacte al administrador.", "error"); }

    render() {
        this.formValidation.validate();
        var validationState = this.formValidation.state;
        if (!this.loginRandom) this.loginRandom = 1 + Math.floor((4 - 1) * Math.random());

        var logoAppSrc = this.getBrandedLogo("logo-login-app.png");
        var logoCompanySrc = this.getBrandedLogo("logo-login-company.png", "frontend.logos.company.visible");
        var logoPoweredBySrc = this.getBrandedLogo("logo-login-powered-by.png", "frontend.logos.poweredBy.visible");
        var showRecovery = this.state.showRecovery;

        return (
            <React.Fragment>
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
                {this.state.loading && <Loading hideSpinner />}
                <div className="app-content content">
                    <div className="content-wrapper">
                        <div className="content-body">
                            <video className="video-login-bg" autoPlay muted loop poster={process.env.PUBLIC_URL + "/images/images-login/image" + this.loginRandom + ".png"}>
                                <source src={process.env.PUBLIC_URL + "/images/videos-login/video" + this.loginRandom + ".mp4"} type="video/mp4" />
                            </video>
                            <section className="flexbox-container">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <div className="col-11 col-sm-8 col-md-6 col-lg-4 p-0" style={{maxWidth: '380px'}}>
                                        <div className="card border-0 m-0" style={{borderRadius: '1rem', boxShadow: '0 15px 35px rgba(0,0,0,0.2)'}}>

                                            <div className="card-header border-0 text-center pb-0" style={{paddingTop: '2rem'}}>
                                                <img src={logoAppSrc} alt="App Logo" className="img-fluid center-block" style={{ maxHeight: '90px', objectFit: 'contain' }} onError={function(e) { e.target.onerror=null; e.target.src="/images/company/logo-login-app.png"; }} />
                                            </div>

                                            <div className="card-body" style={{padding: '1.5rem 1.5rem 1rem'}}>
                                                <h5 className="text-center font-weight-bold text-muted mb-2">
                                                    <FormattedMessage id="2fa.totp.verificar.titulo" defaultMessage="Verificación 2FA" />
                                                </h5>
                                                <p className="text-center text-muted mb-3" style={{fontSize:'13px'}}>
                                                    {showRecovery
                                                        ? <FormattedMessage id="2fa.totp.verificar.subtitulo_recovery" defaultMessage="Ingrese un código de recuperación" />
                                                        : <FormattedMessage id="2fa.totp.verificar.subtitulo" defaultMessage="Ingrese el código de su aplicación de autenticación" />
                                                    }
                                                </p>
                                                <form className="form-horizontal" noValidate onSubmit={showRecovery ? this.handleRecoverySubmit : this.handleCodeSubmit}>
                                                    <fieldset className="form-group position-relative has-icon-left mb-1">
                                                        <input
                                                            type="text"
                                                            className="form-control text-center"
                                                            style={{borderRadius: '8px', height:'45px', fontSize:'18px', letterSpacing:'2px'}}
                                                            name="code"
                                                            placeholder={showRecovery ? "XXXXXXXXXXXXXXXX" : "000000"}
                                                            maxLength={showRecovery ? 16 : 6}
                                                            required
                                                            onChange={this.handleFormChange}
                                                            value={this.state.formData.code}
                                                        />
                                                        <div className="form-control-position" style={{top:'3px'}}><i className="la la-key"></i></div>
                                                    </fieldset>

                                                    <button type="submit" className="btn btn-primary btn-block shadow-sm mt-3" style={{borderRadius: '8px', height:'42px', fontWeight: '500'}} disabled={!validationState.form.valid}>
                                                        <FormattedMessage id="2fa.totp.verificar.boton" defaultMessage="Verificar" />
                                                    </button>

                                                    <button type="button" className="btn btn-link btn-block mt-2 text-muted" style={{fontSize:'12px'}} onClick={function() { this.setState({ showRecovery: !showRecovery, formData: { code: '' } }); }.bind(this)}>
                                                        {showRecovery
                                                            ? <FormattedMessage id="2fa.totp.verificar.usar_codigo" defaultMessage="Usar código de aplicación" />
                                                            : <FormattedMessage id="2fa.totp.verificar.usar_recovery" defaultMessage="Usar código de recuperación" />
                                                        }
                                                    </button>

                                                    <button type="button" className="btn btn-link btn-block mt-1 text-muted" onClick={this.handleGoHome.bind(this)}>
                                                        <FormattedMessage id="2fa.totp.verificar.volver_inicio" defaultMessage="Volver al inicio" />
                                                    </button>
                                                </form>

                                                <div className="mt-3 pt-3" style={{borderTop: '1px solid #f3f3f3'}}>
                                                    <div className="row align-items-center">
                                                        <div className="col-6 text-left">{logoCompanySrc && <img src={logoCompanySrc} alt="Company" className="img-fluid" style={{maxHeight: '35px', maxWidth: '100%', objectFit:'contain'}} onError={function(e) { e.target.onerror=null; e.target.src="/images/company/logo-login-company.png"; }} />}</div>
                                                        <div className="col-6 text-right">{logoPoweredBySrc && <img src={logoPoweredBySrc} alt="Powered By" className="img-fluid" style={{maxHeight: '30px', maxWidth: '100%', objectFit:'contain'}} onError={function(e) { e.target.onerror=null; e.target.src="/images/company/logo-login-powered-by.png"; }} />}</div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default injectIntl(TwoFATotp);
